import * as React from 'react';
import { navigate } from 'router';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import TransactionReceiptPopup from '~/apps/shared/containers/transactions/TransactionReceiptPopup';


export default function({ transactionId }) {
  return (
    <CurrentOrgInjector
      component={TransactionReceiptPopup}
      transactionId={transactionId}
      onReturn={() => navigate('sender.transactions')}
    />
  );
};
